<template>
  <div>
    <h1>News Feed</h1>

    <template v-for="item in posts">
      <post-view :item="item" :users="optionUserItemsById" />
    </template>
  </div>
</template>

<script>
import { CreateCodeTableFetchMixin } from "../../vue-ocom/mixins";
import OSection from "../../vue-ocom/components/layout/OSection";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import PostView from "@/news/feed/PostView";

export default {
  mixins: [CreateCodeTableFetchMixin(["Post", "User"])],
  components: {
    OSection,
    PostView,
  },
  data: () => ({
    posts: [],
  }),
  methods: {
    ...mapMutations(["showMessage"]),
    getPosts() {
      const vm = this;

      var matching_posts = [];

      if (this.isLoggedIn && this.token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
        axios
          .get(`${process.env.VUE_APP_ROOT_API}/news/get_posts/`)
          .then(function (response) {
            response.data.forEach((post) => {
              matching_posts.push(post);
            });

            vm.posts = matching_posts;
          })
          .catch(function (error) {
            // handle error
            vm.showMessage({
              message: "Something went wrong",
              type: "danger",
              show: true,
            });
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      token: "AuthModule/token",
      isLoggedIn: "AuthModule/isLoggedIn",
    }),
  },
  created() {
    if (this.isLoggedIn) {
      this.getPosts();
    }
  },
};
</script>
